import {RepairOrderColumns} from './model/repair-order.columns';
import {RepairOrderTableColumn} from './model/repair-order-table-column';

export class RepairOrderTableUtils {

  public static tableCols: RepairOrderTableColumn[] = [
    {idx: 0, name: 'roNumber', label: 'service.repairOrder.number', sortField: 'roNumber'},
    {idx: 10, name: 'plateNumber', label: 'service.repairOrder.vehicle', sortField: 'plateNumber'},
    {idx: 20, name: 'statusName', label: 'service.repairOrder.status', sortField: 'status'},
    {idx: 30, name: 'priority', label: 'service.repairOrder.priority', sortField: 'priority'},
    {idx: 40, name: 'deadline', label: 'service.repairOrder.deadline', sortField: 'deadline'},
    {idx: 50, name: 'workTypes', label: 'service.repairOrder.workTypes'},
    {idx: 60, name: 'plannedExpenses', label: 'service.repairOrder.financials.planned'},
    {idx: 70, name: 'orderedParts', label: 'service.repairOrder.financials.orderedParts'},
    {idx: 80, name: 'actualExpensesWithoutVat', label: 'service.repairOrder.financials.actual'},
    {idx: 90, name: 'laborTotal', label: 'service.repairOrder.financials.laborTotal'},
    {idx: 100, name: 'partsTotal', label: 'service.repairOrder.financials.partsTotal'}
  ];

  public static defaultTableCols: RepairOrderColumns[] = [
    {name: 'roNumber'},
    {name: 'plateNumber'},
    {name: 'statusName'},
    {name: 'priority'},
    {name: 'deadline'},
    {name: 'workTypes'}
  ];
}
